import React, { useEffect, useState } from 'react';
import { Drawer, Divider, ListItemText, ListItem, List, Collapse, makeStyles, Typography } from '@material-ui/core';
import Routes, { RouteInterface } from '../../routes/routes';
import { useHistory, useLocation } from 'react-router-dom';
import { useAuthentication } from '../../contexts/Authentication';
import { allowedRoute } from '../ProtectedRoute';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import logo from '../../assets/logo.png';
import settings from '../../settings';

const useStyles = makeStyles((theme) => ({
  nested: {
    paddingLeft: theme.spacing(4)
  }
}));

const NavBar = ({ width }: { width: number | string }) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const auth = useAuthentication();
  const [expand, setExpand] = useState<boolean[]>(Routes.map((route, _) => false));
  const [currentPath, setCurrentPath] = useState<string>(location.pathname);

  useEffect(() => {
    setCurrentPath(location.pathname);
  }, [location]);

  useEffect(() => {
    if (auth.isLogged === false) {
      history.push('/login');
    }
  }, [])


  const handleClick = (route: RouteInterface, i: number) => {
    if (route.path && !route.nested) {
      history.push(route.path as string);
    } else if (route.nested) {
      setExpand((oldExpand: boolean[]) => {
        oldExpand[i] = !oldExpand[i];
        return [...oldExpand];
      });
    }
  };

  const setStyle = (route: RouteInterface) => {
    if (route.path === '/') {
      if (currentPath !== '/')
        return {}
    }
    if (
      (route.path && currentPath.startsWith(route.path as string)) ||
      (route.nested && route.nested.some((subroute: RouteInterface) => currentPath.startsWith(subroute.path as string)))
    ) {
      return {backgroundColor: '#f3f3f3'};
    }
    return {};
  };

  return (
    <Drawer
      variant="permanent"
      style={{ width, flexShrink: 0 }}
    >
      <a style={{maxWidth: width, cursor: 'pointer'}} href={settings.frontUrl} target="_blank" rel="noopener noreferrer">
        <img src={logo} alt="Atlantico logo" width={width} style={{padding: 15}}/>
      </a>
      <Divider />
      <List style={{ width }}>
        {Routes.filter(r => !r.invisible && allowedRoute(auth.role, true, r)).sort((a, b) => (a.position - b.position)).map((route, index) => (
          <div key={index}>
            <ListItem button onClick={() => handleClick(route, index)} style={setStyle(route)}>
                <ListItemText primary={route.name} />
                {route.nested && (expand[index] ? <ExpandLess /> : <ExpandMore /> )}
            </ListItem>
            { route.nested &&
              <Collapse in={expand[index]}>
                <List>
                  {route.nested.map((subroute, subindex) => (
                    <ListItem button key={subindex} onClick={() => handleClick(subroute, subindex)} style={setStyle(subroute)} className={classes.nested}>
                      <ListItemText primary={subroute.name}/>
                    </ListItem>
                  ))}
                </List>
              </Collapse>
            }
          </div>
        ))}
      </List>
      <Divider />
      <Typography style={{width, maxWidth: width, padding: 8, fontSize: 12}}>
        Connecté en tant que: <br/><strong>{auth.email}</strong>
      </Typography>
    </Drawer>
  );
}

export default NavBar;